import type { FilterObject, FilterStorageOptions, KeyValueSessionStore } from './types';

export class SessionFilterStorage {
  featureName: string;
  storage: KeyValueSessionStore;
  storageKey: string;

  /**
   * Session storage that is configured to save filter object, sync version.
   */

  constructor({
    featureName = '',
    sessionStore,
    storageKey,
  }: FilterStorageOptions = {}) {
    if (!sessionStore) {
      throw new Error('No session store is provided');
    }

    if (storageKey) {
      this.storageKey = storageKey;
    } else {
      this.storageKey = this.getStorageKey(featureName);
    }

    this.featureName = featureName;
    this.storage = sessionStore;
  }

  // eslint-disable-next-line no-unused-vars
  getStorageKey(featureName?: string): string {
    throw new Error('Not implemented');
  }

  save(filter: FilterObject) {
    this.storage.set(this.storageKey, filter);
  }

  get(): { filter: any } | null {
    const data = this.storage.get(this.storageKey);
    return data ? { filter: data } : null;
  }
}
